import { Component, OnInit } from '@angular/core';
import { PressReleaseService} from '../../../_services/preleases.service';
import { ActivatedRoute, Params } from '@angular/router';
import { ContactService } from '../../../_services/contact.service';

@Component({
  selector: 'app-logos',
  templateUrl: './logos.component.html',
  styleUrls: ['./logos.component.scss']
})
export class LogosComponent implements OnInit {
  country: string;
  language: string;
  logo: any;
  page: any;
  spaceGuide: any;
  minimumSize: any;

  constructor(
    private pressRleaseService: PressReleaseService,
    private route: ActivatedRoute,
    private contactService: ContactService,
  ) { }

  getLogos(country: string, language: string){
    this.pressRleaseService.getLogo(country,language)
    .subscribe(
      resultArray =>{
        this.logo= resultArray;
      },
      error => console.log( 'Error::' + error)
    )
  }
  getCustomPages(country: string, language: string) {
    this.contactService.getCustomPages(country, language)
      .subscribe(
        resJSONData => {
          this.page = resJSONData[0];
          this.spaceGuide = resJSONData[0].LogosSpaceGuide.path;
          this.minimumSize = resJSONData[0].LogosMinimumSizeGuide.path;

        },
        error => console.log('Error ::' + error)
      );
  }
  ngOnInit() {
    this.route.params
    .subscribe(
      (params: Params) => {
        this.country = params['country'];
        this.language = params['language'];
        this.getLogos(this.country, this.language);
        this.getCustomPages(this.country, this.language);

      }
    )
  }

}
